<template>
    <div>
        <!-- 我提交的变更 -->
        <!-- <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">

                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" @change="loadData" @keyup.enter.native="loadData"></el-input>
                </el-form-item>

                <el-button type="primary" @click="loadData">搜索</el-button>
            </el-form>
        </el-card> -->
        
        <el-card>

            <div slot="header">
                <router-link :to="{path:'/dictionaryAdd', query:{ callback: request}}">
                    <el-button type="primary">新增</el-button>
                </router-link>
            </div>

            <el-tabs type="border-card" v-model="keyValue">
                <el-tab-pane
                    v-for="(item, index) in tableData"
                    :key="index"
                    :label="item.key"
                    :name="''+item.key">

                    <el-tabs type="border-card" v-model="envValue">
                        <el-tab-pane
                            v-for="(i, ind) in item.value"
                            :key="ind"
                            :label="getNameByDefault(i.envId, env)"
                            :name="''+i.envId">

                            <el-table :data='i.param'>
                                <el-table-column label="参数名" prop='cname'></el-table-column>

                                <el-table-column label="参数值" prop='value'></el-table-column>

                                <el-table-column label="操作">
                                    <template slot-scope='{row}'>
                                        <router-link :to="{
                                                        path:'/dictionaryAdd', query: {
                                                            type: 'edit',
                                                            envValue,
                                                            keyValue,
                                                            row: row,
                                                            callback: request }
                                                        }">
                                            <el-button type="text">编辑</el-button>
                                        </router-link>
                                        <el-button class="table-del-btn" type="text" @click="deleteRole(row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>

        </el-card>
    </div>
</template>

<script>
    import services from "./dictionary.service";
    export default {
        data() {
            return {
                form:{
                    pageSize:10,
                    pageIndex:1,
                },
                total:null,
                tableData:[],
                loading:true,
                ExportBtn:false,
                keyValue: '',
                envValue: '',

            }
        },

        created() {
            // console.log(this.dictionary);
            this.request();


        },

        computed:{
            dictionary(){
                return this.$store.state.dictionary2;
            },
            env() {
                return this.dictionary.env
            }
        },
        methods: {
            loadData(){
                this.form.pageIndex=1
                this.request();
            },
            request(){
                // 获取列表数据
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                let params = {
                    ...this.form,
                }
                services.dictionaryList(params).then(res => {
                    this.tableData = res;
                })

            },
            deleteRole(row){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    let params = {
                        method: "delete",
                        type: this.keyValue,
                        env: this.envValue,
                        value: row.value,
                        key: row.key,
                        cname: row.cname
                    }
                    services.dictionaryDel(params).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
